{
  "version": 1,
  "asset_id": "3370a1f3-e177-4e7a-867c-50f3894b2f57",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3370a1f3-e177-4e7a-867c-50f3894b2f57/sleeve-dissection-revision-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3370a1f3-e177-4e7a-867c-50f3894b2f57/sleeve-dissection-revision-480.jpg",
  "original_filename": "sleeve-dissection-revision-480.jpg",
  "size": 28809,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T12:43:05Z"
}
